module.exports = __webpack_public_path__ + "media/print/color-settings_color-3347d8ea.png";